<div class="mock-config-form">
  <div class="form-content">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <ix-input
        ixTest="method-name-input"
        formControlName="methodName"
        [label]="'Method Name' | translate"
        [placeholder]="'e.g., pool.create' | translate"
        [required]="true"
      ></ix-input>
      <ix-input
        ixTest="message-pattern-input"
        formControlName="messagePattern"
        [label]="'Message Pattern (Optional)' | translate"
        [hint]="'Regex pattern to match against message content' | translate"
      ></ix-input>

      <ix-radio-group
        ixTest="response-type-radio"
        formControlName="responseType"
        [label]="'Response Type' | translate"
        [options]="responseTypeOptions"
        [required]="true"
      ></ix-radio-group>

      @if (isErrorMode) {
        <ix-checkbox
          ixTest="is-call-error-checkbox"
          formControlName="isCallError"
          [label]="'Configure as CallError' | translate"
        ></ix-checkbox>
      }

      @if (!isErrorMode) {
        <ix-code-editor
          ixTest="response-data-textarea"
          formControlName="responseResult"
          [language]="CodeEditorLanguage.Json"
          [label]="'Response Data' | translate"
          [hint]="'JSON format expected' | translate"
        ></ix-code-editor>
      }

      @if (isErrorMode) {
        <ix-combobox
          ixTest="error-code-input"
          formControlName="errorCode"
          [label]="'Error Code' | translate"
          [required]="true"
          [hint]="'Select a standard code or enter a custom value' | translate"
          [provider]="errorCodeProvider"
          [allowCustomValue]="true"
        ></ix-combobox>
        <ix-input
          ixTest="error-message-input"
          formControlName="errorMessage"
          [label]="'Error Message' | translate"
          [required]="true"
          [hint]="'Human-readable error message' | translate"
        ></ix-input>
        
        @if (isCallErrorMode) {
          <ix-select
            ixTest="call-error-errname-select"
            formControlName="callErrorErrname"
            [label]="'Error Name (errname)' | translate"
            [options]="errorNameOptions"
            [hint]="'Standard error name (e.g., EINVAL, EACCES)' | translate"
          ></ix-select>
          <ix-input
            ixTest="call-error-code-input"
            formControlName="callErrorCode"
            type="number"
            [label]="'Error Code (error)' | translate"
            [hint]="'Integer error code (e.g., 22 for EINVAL, 13 for EACCES)' | translate"
          ></ix-input>
          <ix-input
            ixTest="call-error-reason-input"
            formControlName="callErrorReason"
            [label]="'Error Reason' | translate"
            [hint]="'Human-readable reason for the error' | translate"
          ></ix-input>
          <ix-code-editor
            ixTest="call-error-extra-textarea"
            formControlName="callErrorExtra"
            [language]="CodeEditorLanguage.Json"
            [label]="'Extra Data (Optional)' | translate"
            [hint]="'Additional error context (e.g., validation errors) in JSON format' | translate"
          ></ix-code-editor>
          <ix-code-editor
            ixTest="call-error-trace-textarea"
            formControlName="callErrorTrace"
            [language]="CodeEditorLanguage.Json"
            [label]="'Stack Trace (Optional)' | translate"
            [hint]="'Mock stack trace in JSON format (auto-generated by default)' | translate"
          ></ix-code-editor>
        } @else {
          <ix-code-editor
            ixTest="error-data-textarea"
            formControlName="errorData"
            [language]="CodeEditorLanguage.Json"
            [label]="'Error Data (Optional)' | translate"
            [hint]="'Additional error details in JSON format' | translate"
          ></ix-code-editor>
        }
      }

      <ix-input
        ixTest="response-delay-input"
        formControlName="responseDelay"
        type="number"
        [label]="'Response Delay (ms)' | translate"
        [placeholder]="'0' | translate"
        [hint]="'Delay in milliseconds before returning the response' | translate"
      ></ix-input>

      <div class="events-section">
        <label>{{ 'Events (Optional)' | translate }}</label>
        <ix-job-event-builder
          [events]="form.value.events"
          (eventsChange)="onEventsChange($event)">
        </ix-job-event-builder>
      </div>
    </form>
  </div>

  <div class="form-actions">
    <button mat-button ixTest="cancel-button" type="button" (click)="onCancel()">
      {{ 'Cancel' | translate }}
    </button>
    <button mat-button ixTest="submit-button" color="primary" type="button" [disabled]="form.invalid" (click)="onSubmit()">
      {{ isEditMode ? ('Update' | translate) : ('Create' | translate) }}
    </button>
  </div>
</div>
